<!--
 * @Description: 提示框全局组件
 * @Date: 2019-09-27 14:47:16
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 15:58:29
 -->
<template>
  <div>
    <v-snackbar v-model="snackbar" >
      {{ text }}
      <v-btn color="deep-orange" icon @click="snackbar = false" :timeout="timeout" >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      timeout: 3000,
      snackbar: false
    };
  },
  methods: {
    getProductCheckResult(options) {
      this.text = options.text;
      this.timeout = options.timeout;
      this.snackbar = options.snackbar;
    }
  }
};
</script>